// extracted by mini-css-extract-plugin
export default {"Service__Section":"Service_Service__Section__3cup3","Service__Item":"Service_Service__Item__2IJQK","Title":"Service_Title__cSMCn","Icon":"Service_Icon__pQ2Kh"};